import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';
import { getErrMessages } from 'src/app/utils/errorHandler';
import { removeToken } from 'app/services/localStorage';
import { logout } from 'app/store/auth';
import { showMessage } from '../core/messageSlice';
import { partialMerge } from 'app/utils/transformers';

export const getConfigFile = createAsyncThunk(
  'config/get',
  async ({ fileDirectory = './envpaths.json' }, { dispatch, getState, rejectWithValue }) => {
    try {
      const { config } = getState().config;
      const response = await fetch(fileDirectory);
      const envPaths = await response.json();
      console.info('[FILE ENVPATHS]:', envPaths);
      if (typeof envPaths !== 'object' || _.isEmpty(envPaths))
        return rejectWithValue(['Environment file parameters not found']);
      if (!_.has(envPaths, 'api') || _.isEmpty(envPaths.api))
        return rejectWithValue(['Environment file does not have a API config']);
      if (!_.has(envPaths, 'sockets') || _.isEmpty(envPaths.sockets)) {
        console.warn(['Environment file does not have any Sockets config']);
      }
      // Returns config object
      return partialMerge(config, envPaths);
    } catch (error) {
      console.error(error);
      const errArray = getErrMessages(error);
      dispatch(
        showMessage({
          message: `Error: ${errArray.join(', ')}`,
        })
      );
      return rejectWithValue(errArray);
    }
  }
);

export const getConfigCompany = createAsyncThunk(
  'config/company',
  async ({ _request, props = [] }, { dispatch, rejectWithValue }) => {
    if (typeof _request !== 'function') {
      const errorMessage = '_request must be a function';
      console.error(errorMessage);
      return rejectWithValue({ errors: [errorMessage] });
    }
    try {
      const response = await _request(...props);
      const { data } = await response;
      return _.omit(data, ['updated_at', 'created_at', 'deleted_at']);
    } catch (error) {
      const errArray = getErrMessages(error);
      const message = errArray.join();
      dispatch(showMessage({ message }));

      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        removeToken();
        dispatch(logout());
        errArray.unshift(`${error.response.status}`);
      }

      return rejectWithValue(errArray);
    }
  }
);
